import { compose, withProps } from 'recompose';
import { noop } from 'lodash';

import PropTypes from 'utils/prop-types';

import {
  geocode as geocodeGoogleMaps,
  reverseGeocode as reverseGeocodeGoogleMaps,
} from './geocoders/googleMapsGeocoder';

import withGoogleMapJS from './withGoogleMapJS';

/* istanbul ignore next */
function geocode({ googleMaps }, address) {
  if (!googleMaps) return noop;
  return geocodeGoogleMaps(googleMaps, address);
}

/* istanbul ignore next */
function reverseGeocode({ googleMaps }, location) {
  if (!googleMaps) return noop;
  return reverseGeocodeGoogleMaps(googleMaps, location);
}

/* istanbul ignore next */
const withGeocoder = compose(
  withGoogleMapJS,
  withProps(ownerProps => ({
    geocode: address => geocode(ownerProps, address),
    reverseGeocode: location => reverseGeocode(ownerProps, location),
  })),
);

withGeocoder.propTypes = {
  googleMaps: PropTypes.googleMapsApi,
};

withGeocoder.defaultProps = {
  googleMaps: null,
};

export default withGeocoder;



// WEBPACK FOOTER //
// ./utils/mapping/withGeocoder.js